import Vue from 'vue'
const BaseComponents = require.context('./', true, /\index.js$/)
const ctComs = () => {
  BaseComponents.keys().forEach(com => {
    const mb = BaseComponents
    const value = BaseComponents(com)
    Vue.use(value.default)
  })
}
export default ctComs
